import accessUtils from '../utils/accessUtils';

import { useGetListingDetails } from './queries/properties';

/**
 * `accessUtils.isPhotoUploadRestricted` plus the loading window, for entry points that can act before
 * details resolve. Unknown fails closed: an enabled entry point in that window would let a restricted
 * listing generate an upload link. A failed fetch reads as unrestricted, matching the dropzone beside
 * it — otherwise one error would drop the entry point for the rest of the session.
 */
export const useIsPhotoUploadRestricted = (listingAlias: string) => {
  const { data: listingDetails, isPending } = useGetListingDetails(listingAlias);

  // The query only runs with an alias, so without one `isPending` never clears and would restrict forever.
  const isRestrictionUnknown = Boolean(listingAlias) && isPending;

  return isRestrictionUnknown || accessUtils.isPhotoUploadRestricted(listingDetails);
};
